import React from 'react';
import { Popover } from '@mui/material';

export default function FilterPopover({ open, anchorEl, onClose, children }) {
  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
      transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      PaperProps={{
        sx: {
          p: 1.5,
          maxWidth: 860,
          boxShadow: '0 4px 20px rgba(0,0,0,0.12)',
          borderRadius: 2,
        },
      }}
    >
      {children}
    </Popover>
  );
}
